const ajaxActions = (function($) {
  $("#page").on("click", "[data-ajax]", function() {
    url = $(this).data("ajax");
    params = $(this).data("ajax-parameters");
    method = $(this).data("ajax-method") || "POST";
    confirm = $(this).data("ajax-confirm");
    $el = $(this);

    if (typeof confirm !== "undefined" && $el.data("ajax-confirmed") != "1") {
      $el.find("span").text(confirm);
      $el.data("ajax-confirmed", 1);
      return;
    }

    $el.trigger("ajax:" + method.toLowerCase() + ":" + url + ":start", [
      params
    ]);

    $.ajax({
      url: window.mtn.api.rest_url + url,
      method: method,
      beforeSend: function(xhr) {
        xhr.setRequestHeader("X-WP-Nonce", window.mtn.api.nonce);
      },
      data: params,
      success: function(response) {
        $el.trigger("ajax:" + method.toLowerCase() + ":" + url + ":success", [
          response,
          params
        ]);
      },
      error: function(request, status, error) {
        $el.trigger("ajax:" + method.toLowerCase() + ":" + url + ":error", [
          error,
          params
        ]);
      }
    });
  });
})(window.jQuery);
